import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { EWayBillPopupComponent } from '../e-way-bill-popup/e-way-bill-popup.component';
import { CompanyModel } from 'src/app/core/models/masters/company-master-model';
import { ElectronicProtocol, EwayBillDetails, EWayDataModel, MainHsnModel, StateModel, TransporterModel } from 'src/app/core/models/masters/eway.model';
import { UserProfileModel } from 'src/app/services/models/userModel';
import { EWayService } from '../e-way.service';
import { WrapperStandardRequest } from 'src/app/infrastructure/infrastructure-services/common/models/wrapper.model';

@Component({
  selector: 'app-e-way-tab',
  templateUrl: './e-way-tab.component.html',
  styleUrls: ['./e-way-tab.component.css']
})
export class EWayTabComponent implements OnInit {
  threeDots: boolean = false;
  withIRN: boolean = true;
  EwayBillSaveData: EwayBillDetails = new EwayBillDetails();
  EwayBillGetData: EwayBillDetails = new EwayBillDetails();
  waitingStatus: string = 'W';
  screenType: number = 0;
  logedInUserData: UserProfileModel = new UserProfileModel();
  companyData: CompanyModel = new CompanyModel();
  protected sessionService: any;
  subType: Array<any> = new Array();
  docType: Array<any> = new Array();
  canRemarks: Array<any> = new Array();
  vehicleType: Array<any> = new Array();
  transMode: Array<any> = new Array();
  transportList: Array<any> = new Array();
  allTransportData: Array<any> = new Array();
  allStates: Array<any> = new Array();
  hsnList: Array<any> = new Array();
  allHsnData: Array<any> = new Array();
  transportCode: string = '';
  ewayDocEntry: number = 0;
  docData: any;
  shipToData: Object = new Object({ key: new Array(), value: '' });
  ElectronicProtocolsData: ElectronicProtocol = new ElectronicProtocol();
  methodTypePatch: boolean = false;
  IRN: string = '';
  reqBody: WrapperStandardRequest<any> = new WrapperStandardRequest<any>();
  isInventoryTransfer: boolean = false;

  eDocGenerationType = [
    { key: 'Not Relevant', value: 'edgt_NotRelevant' },
    { key: 'Generate', value: 'edgt_Generate' },
    { key: 'Generate-Later', value: 'edgt_GenerateLater' }
  ];
  eDocFormat = [
    { key: 'e-Way Bill', value: -9 },
    // { key: 'e-Way Bill', value: -9},
    // { key: 'E-Billing-Invoice	', value: -10 },
    // { key: 'E-Billing-CreditMemo', value: -11 }
  ]
  docStatus = [
    { key: 'Waiting', value: 'W' },
  ];
  updateReason = [
    { key: 'Due to Break Down', value: '1' },
    { key: 'Due to Transhipment', value: '2' },
    { key: 'Others (Pls. Specify)', value: '3' },
    { key: 'First Time', value: '4' },
  ];

  supplyTypeAR = [
    { key: 'Outword', value: 'ewb_st_Outward' },
    // { key: 'Inward', value: 'ewb_st_Inward' },
  ];
  supplyTypeIV = [
    { key: 'Outword', value: 'O' },
    // { key: 'Inward', value: 'I' },
  ];

  transactionTypeAR = [
    { key: 'Regular', value: 'ewb_tt_Regular' },
    { key: 'Bill To-Ship', value: 'ewb_tt_BillToShipTo' },
    { key: 'Bill From-Dispatch From', value: 'ewb_tt_BillFromDispathFrom' },
    { key: 'Combination of 2 and 3', value: 'ewb_tt_CombinationOfBillAndShip' },
  ];

  transactionTypeIV = [
    { key: 'Regular', value: '1' },
    { key: 'Bill To-Ship', value: '2' },
    { key: 'Bill From-Dispatch From', value: '3' },
    { key: 'Combination of 2 and 3', value: '4' },
  ];
  warehouseCode: string | null = '';
  // reqData: WrapperInputModel<EWayDataModel> = new WrapperInputModel<EWayDataModel>();
  docEntry: string | null = '';
  objectType: string = '';
  screenName: string | null = '';


  constructor(private dialog: MatDialog, private ewayService: EWayService) { }

  ngOnInit(): void {
  }

  showEWayBillPopup() {
    let eWayBillDialogRef = this.dialog.open(EWayBillPopupComponent, {
      width: '1000px',
      height: '80%',
      data: {
        eWayGetData: this.EwayBillGetData,
        customerCode: this.docData?.cardCode,
        wareHouseCode: this.getWareHouseCode(),
        screenType: this.screenType,
        docEntry: this.docEntry,
        objectType: this.objectType,
        docData: this.docData,
        transportCode: this.setTransportCode(),
        methodTypePatch: this.methodTypePatch,
        ewayDocEntry: this.ewayDocEntry,
        withIRN: this.withIRN,
        shipToData: this.shipToData,
        IRN: this.IRN,
        masterList: {
          transMode: this.transMode,
          vehicleType: this.vehicleType,
          subType: this.subType,
          docType: this.docType,
          transportList: this.transportList,
          stateList: this.allStates,
          allTransportData: this.allTransportData,
          hsnList: this.hsnList,
          allHsnData: this.allHsnData,
          canRemarks: this.canRemarks,
          updateReason: this.updateReason,
          supplyType: this.objectType == '13' ? this.supplyTypeAR : this.supplyTypeIV,
          transactionType: this.objectType == '13' ? this.transactionTypeAR : this.transactionTypeIV
        }
      },
      panelClass: 'dynamictable'
    });
    eWayBillDialogRef.afterClosed().subscribe(res => {
      if (res) {
        this.EwayBillSaveData = res?.saveData;
        this.EwayBillGetData = res?.orgValue;
        this.methodTypePatch = res?.MethodTypePatch;
        this.transportCode = res?.transportCode;
        this.ewayDocEntry = res?.ewayDocEntry;
        this.docData = { ...this.docData, ...res.docData };
      }
    });
  }

  callAllDropDownApis() {
    this.getTransportationMode();
    this.getVehicleType();
    this.getSubType();
    this.getDocumentType();
    this.getHSNType();
    this.getStateList();
    this.getCancellationRemarks();
  }

  getSubType() {
    this.ewayService.getSubType(this.reqBody).subscribe(res => {
      this.subType = res?.responseData.subType
    });
  }

  getDocumentType() {
    this.ewayService.getDocumentType(this.reqBody).subscribe(res =>
      this.docType = res?.responseData.documentType);
  }

  getTransportationMode() {
    this.ewayService.getTransportationMode(this.reqBody).subscribe(res =>
      this.transMode = res?.responseData.transportationMode.filter((el: any) => el.modeName));
  }

  getCancellationRemarks() {
    this.ewayService.getCancellationRemarks(this.reqBody).subscribe(res => this.canRemarks = res?.responseData);
  }

  getVehicleType() {
    this.ewayService.getVehicleType(this.reqBody).subscribe(res => {
      if (res) {
        this.vehicleType = res?.responseData.vehicleType.filter((el: any) => el.typeName)
        this.getTransportersType();
      }
    });
  }

  getStateList() {
    this.reqBody.RequestData = null;
    this.reqBody.SortColumn = 'name';
    this.reqBody.PageRecordCount = 100;
    this.ewayService.getStateList(this.reqBody).subscribe(res => {
      if (res) {
        res?.responseData.forEach((el: any, i: number) => {
          let stateModel = new StateModel();
          stateModel['#'] = i;
          stateModel.Code = el.code;
          stateModel.Country = el.country;
          stateModel.CountryName = el.countryName;
          stateModel.Name = el.name;
          stateModel.GSTCode = el.gstCode;
          this.allStates.push(stateModel);
        })
      }
    });
  }

  getTransportersType() {
    this.ewayService.getTransporters(this.reqBody).subscribe(res => {
      if (res) {
        res?.responseData.forEach((el: any, i: number) => {
          let transportModel = new TransporterModel();
          transportModel['#'] = i;
          transportModel.TransporterCode = el.transporterCode;
          transportModel.TransporterName = el.transporterName;
          transportModel.TransporterId = el.transporterID;
          transportModel.VehicleType = el.vehicleType;
          transportModel.VehicleNo = el.vehicleNo;
          transportModel.Mode = el.modeCode;
          transportModel.TransporterEntry = el.absEntry;
          transportModel.TransporterLineNumber = el.absEntry;
          this.transportList.push(transportModel);
          this.allTransportData.push(el);
        })
      }
    });
  }

  getHSNType() {
    this.ewayService.getHSNType(this.reqBody).subscribe(res => {
      if (res) {
        this.allHsnData = res?.responseData.ochpData
        res?.responseData.ochpData?.forEach((el: any, i: number) => {
          let hsnModel = new MainHsnModel();
          hsnModel['#'] = i;
          hsnModel.Chapter = el.chapter;
          hsnModel.Heading = el.heading;
          hsnModel.SubHeading = el.subHeading;
          hsnModel.Description = el.dscription;
          this.hsnList.push(hsnModel);
        })
      }
    });
  }

  getWareHouseCode() {
    let warehouseCode: string | null = '';
    let value: string = '';
    switch (this.screenName) {
      case 'Sales Invoice':
        value = this.docData?.documentLines.some((el: any) => el.warehouseCode);
        warehouseCode = value ? this.docData?.documentLines[0].warehouseCode : '';
        break;
      // case 'Inventory Transfer':
      //   value = this.docData?.stockTransferLines.some((el: any) => el.fromWarehouseCode);
      //   warehouseCode = value ? this.docData?.stockTransferLines[0].fromWarehouseCode : '';
      //   break;
    }
    return warehouseCode
  }

  setTransportCode() {
    let transportData: string = '';
    if (this.objectType == '13') {
      transportData = this.ewayService.getValues(this.allTransportData, (this.EwayBillGetData).TransporterEntry, 'absEntry', 'transporterCode')
    } else {
      transportData = this.transportCode;
    }
    return transportData
  }

  getEwayBill(docEntry: number): any {
    this.ewayService.getSalesInvoice(docEntry).subscribe((res: any) => {
      let ewayBillObj: EwayBillDetails = new EwayBillDetails();
      if (res) {
        const value = res.EWayBillDetails;
        this.methodTypePatch = true;
        ewayBillObj.SupplyType = value?.SupplyType;
        ewayBillObj.SubType = value?.SubType;
        ewayBillObj.DocumentType = value?.DocumentType;
        ewayBillObj.TransactionType = value?.TransactionType;
        ewayBillObj.MainHSNEntry = value?.MainHSNEntry;
        ewayBillObj.EWayBillNo = value?.EWayBillNo;
        ewayBillObj.EWayBillDate = value?.EWayBillDate;
        ewayBillObj.EWayBillExpirationDate = value?.EWayBillExpirationDate;
        ewayBillObj.TransporterID = value?.TransporterID;
        ewayBillObj.TransporterName = value?.TransporterName;
        ewayBillObj.TransporterDocNo = value?.TransporterDocNo;
        ewayBillObj.TransporterDocDate = value?.TransporterDocDate;
        ewayBillObj.TransportationMode = Number(value?.TransportationMode);
        ewayBillObj.TransporterEntry = value?.TransporterEntry;
        ewayBillObj.Distance = value?.Distance;
        ewayBillObj.VehicleType = value?.VehicleType;
        ewayBillObj.VehicleNo = value?.VehicleNo;
        ewayBillObj.BillFromName = value?.BillFromName;
        ewayBillObj.BillFromGSTIN = value?.BillFromGSTIN;
        ewayBillObj.BillFromStateGSTCode = value?.BillFromStateGSTCode;
        ewayBillObj.DispatchFromAddress1 = value?.DispatchFromAddress1;
        ewayBillObj.DispatchFromAddress2 = value?.DispatchFromAddress2;
        ewayBillObj.DispatchFromZipCode = value?.DispatchFromZipCode;
        ewayBillObj.BillToName = value?.BillToName;
        ewayBillObj.BillToGSTIN = value?.BillToGSTIN;
        ewayBillObj.BillToStateGSTCode = value?.BillToStateGSTCode;
        ewayBillObj.ShipToAddress1 = value?.ShipToAddress1;
        ewayBillObj.ShipToAddress2 = value?.ShipToAddress2;
        ewayBillObj.ShipToZipCode = value?.ShipToZipCode;
        ewayBillObj.DispatchFromPlace = value?.DispatchFromPlace;
        ewayBillObj.ShipToPlace = value?.ShipToPlace;
        this.ewayDocEntry = value?.DocEntry;
        this.docEntry = value?.DocEntry;
        // this.transportCode = value?.TransCode;
        this.ewayService._getEWayData(docEntry, this.objectType).subscribe(res => {
          if (res && res.value.length) {
            const response = res.value[0];
            ewayBillObj.EWayBillNo = response.U_UTL_ST_EwayNo;
            ewayBillObj.EWayBillDate = response.U_UTL_ST_EWBGenDt;
            ewayBillObj.EWayBillExpirationDate = response.U_UTL_ST_EWBExpDt;
            this.EwayBillGetData = ewayBillObj;
          }
        })
      }
      this.EwayBillGetData = ewayBillObj;
    });
  }

  getInventoryEwayBill(docEntry: number): any {
    this.ewayService.getInventoryEway(docEntry, 67).subscribe(res => {
      let ewayBillObj: EwayBillDetails = new EwayBillDetails();
      if (res?.value.length > 0) {
        let value = res?.value[0];
        this.methodTypePatch = true;
        ewayBillObj.SupplyType = value?.U_UTL_ST_SuplyType;
        ewayBillObj.SubType = Number(value?.U_UTL_ST_SubSplyTyp);
        ewayBillObj.DocumentType = value?.U_UTL_ST_DocType;
        ewayBillObj.TransactionType = value?.U_UTL_ST_TransTyp;
        ewayBillObj.MainHSNEntry = value?.U_UTL_ST_MainHsnEnt;
        ewayBillObj.EWayBillNo = value?.U_UTL_ST_EwayBillNo;
        ewayBillObj.EWayBillDate = value?.U_UTL_ST_EwbDate;
        ewayBillObj.EWayBillExpirationDate = value?.U_UTL_ST_ExpireDate;
        ewayBillObj.TransporterID = value?.U_UTL_ST_TransID;
        ewayBillObj.TransporterName = value?.U_UTL_ST_TransName;
        ewayBillObj.TransporterDocNo = value?.U_UTL_ST_TransDocNo;
        ewayBillObj.TransporterDocDate = value?.U_UTL_ST_TransDate;
        ewayBillObj.TransportationMode = Number(value?.U_UTL_ST_TransMode);
        ewayBillObj.Distance = value?.U_UTL_ST_Distance;
        ewayBillObj.VehicleType = value?.U_UTL_ST_VehicleTyp;
        ewayBillObj.VehicleNo = value?.U_UTL_ST_VehicleNo;
        ewayBillObj.BillFromName = value?.U_UTL_ST_FrmTraName;
        ewayBillObj.BillFromGSTIN = value?.U_UTL_ST_FrmGSTN;
        ewayBillObj.DispatchFromAddress1 = value?.U_UTL_ST_FrmAdd1;
        ewayBillObj.DispatchFromAddress2 = value?.U_UTL_ST_FrmAdd2;
        ewayBillObj.DispatchFromZipCode = value?.U_UTL_ST_FrmZipCode;
        ewayBillObj.BillToName = value?.U_UTL_ST_ToTraName;
        ewayBillObj.BillToGSTIN = value?.U_UTL_ST_ToGSTN;
        ewayBillObj.ShipToAddress1 = value?.U_UTL_ST_ToAdd1;
        ewayBillObj.ShipToAddress2 = value?.U_UTL_ST_ToAdd2;
        ewayBillObj.ShipToZipCode = value?.U_UTL_ST_ToZipCode;
        ewayBillObj.DispatchFromPlace = value?.U_UTL_ST_FrmPlace;
        ewayBillObj.ShipToPlace = value?.U_UTL_ST_ToPlace;
        this.docData.U_UTL_ST_CANDAT = value?.U_UTL_ST_CANDT;
        this.docData.U_UTL_CARES = value?.U_UTL_ST_CARES;
        this.docData.U_UTL_ST_CANRMK = value?.U_UTL_ST_CANRMK;
        this.docData.U_UTL_ST_UPRESR = value?.U_UTL_ST_UPRESR;
        this.docData.U_UTL_ST_URMK = value?.U_UTL_ST_URMK;
        this.docData.U_UTL_ST_EWayUpDt = value?.U_UTL_ST_UPDT;
        this.ewayDocEntry = value?.DocEntry;
        this.transportCode = value?.U_UTL_ST_TransCode;
      }
      this.EwayBillGetData = ewayBillObj;
    });
  }

}
